export default "__VITE_ASSET__Cu9Im6i___"